import React from "react"
import { css } from "@emotion/core"
import CommentForm from "./comment_form"
import CommentList from "./comment_list"

class Comments extends React.Component {
  constructor(props) {
    super(props)
  }

  trimSlashes(str) {
    if (str.charAt(0) == "/") {
      str = str.substr(1)
    }
    if (str.charAt(str.length - 1) == "/") {
      str = str.substr(0, str.length - 1)
    }
    return str
  }

  render() {
    return (
      <div
        css={css`
          margin-top: 60px;
        `}
      >
        <CommentForm slug={this.props.slug}></CommentForm>
        <CommentList comments={this.props.comments}></CommentList>
      </div>
    )
  }
}

export default Comments
